const scrollbarThumbColor = '#C1C1C1';
const scrollbarThumbHoverColor = '#A8A8A8';
const scrollbarTrackColor = 'rgba(76, 76, 76, 0.075)';
export const customizeScrollBar = theme => ({
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '&:hover': {
    scrollbarColor: `${scrollbarThumbColor} ${scrollbarTrackColor}`,
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      display: 'block',
      width: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: scrollbarThumbColor,
      borderRadius: theme.SHAPE.ROUNDED_CORNERS,
      '&:hover': {
        backgroundColor: scrollbarThumbHoverColor
      }
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: scrollbarTrackColor
    }
  }
});